import React, { useState } from "react";
import { Box, Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import AppIcon from "ui/components/icons/AppIcon";
import { iconCheckBox, iconCheckBoxOutlineBlank } from "ui/components/icons";
import { useAdvancedViewFiltersStore } from "data/store/global-search/AdvancedViewFiltersStore";
import { GlobalSearchSelectOption } from "data/@types/GlobalSearchData";

export const CheckboxOptionsFilter = ({
  options,
  label,
  activityType,
}: {
  options: string[];
  label: string;
  activityType: GlobalSearchSelectOption;
}) => {
  const activeFilters = useAdvancedViewFiltersStore(
    (state) => state.filtersByActivity[activityType] || {},
  );
  const setActiveFilters = useAdvancedViewFiltersStore(
    (state) => state.setFiltersForActivity,
  );

  const [checkedOptions, setCheckedOptions] = useState<string[]>(() => {
    const value = activeFilters[label]?.valueText;
    if (Array.isArray(value)) {
      return value;
    }
    if (typeof value === "string") {
      return [value];
    }
    return [];
  });

  const handleToggle = (option: string) => {
    const currentIndex = checkedOptions.indexOf(option);
    let newSelected = [];

    if (currentIndex === -1) {
      newSelected = [...checkedOptions, option];
    } else {
      newSelected = checkedOptions.filter((item) => item !== option);
    }
    setCheckedOptions(newSelected);
  };

  React.useEffect(() => {
    setActiveFilters(activityType, {
      ...activeFilters,
      [label]: {
        ...activeFilters[label],
        valueText: checkedOptions,
      },
    });
  }, [checkedOptions]);

  return (
    <Box>
      <FormGroup>
        {options.map((option) => (
          <FormControlLabel
            key={option}
            control={
              <Checkbox
                id={option}
                checked={checkedOptions.includes(option)}
                icon={<AppIcon icon={iconCheckBoxOutlineBlank} />}
                checkedIcon={<AppIcon icon={iconCheckBox} />}
                color="primary"
                onChange={() => handleToggle(option)}
              />
            }
            label={option}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              fontSize: "1.2rem",
              paddingLeft: "3.2rem",
            }}
          />
        ))}
      </FormGroup>
    </Box>
  );
};
